module.exports = __webpack_public_path__ + "img/discord.12d763e7.png";